import { IPaginatedLandingContent } from './models/paginated-landing-content'
import { Filter } from './components/paginated-landing-content-app';

export default function matchesAnyRoleHelper(item: IPaginatedLandingContent, filter: Filter[]) {
    let roleResults = item.roles;
    let matchesRole;

    if (!roleResults || roleResults.length == 0) {
        return false
    }
    // if any filters match any roles on this item
    for (let i = 0; i < roleResults.length; i++) {
        // if any role result matches
        if (filter.length > 0) {
            for (let n = 0; n < filter.length; n++) {
                if (roleResults[i].toLowerCase() === filter[n].id.toLowerCase()) {
                    matchesRole = true;
                    break;
                }
            }
            if (matchesRole) {
                break;
            }
        }
    }
    return matchesRole;
}